import { IHttpResponse } from '../httpTypes';

export enum PurchasedPlaceStatus {
  AVAILABLE = 'available',
  ASSIGNED = 'assigned',
  EXPIRED = 'expired',
  CANCELLED = 'cancelled'
}

export interface IPurchasedPlace {
  _id: string;
  transaction: string;
  extra_info: {
    coverUrl: string
  }
  buyer: {
    email: string;
    profile: {
      first_name: string;
      last_name: string;
    }
  };
  courseScheduling: {
    metadata: {
      service_id: string;
      program: string;
    }
  };
  programCode: string;
  programName: string;
  status: PurchasedPlaceStatus;
  enrollment: {
    user: string;
  };
  assignedTo: {
    email: string;
    profile: {
      first_name: string;
      last_name: string;
    }
  };
  assignedAt: string;
  expiresAt: string;
}

export interface IPurchasedPlacesResponse extends IHttpResponse {
  purchasedPlaces: IPurchasedPlace[];
}